import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Segment } from "semantic-ui-react";
import PageHeader from "../../components/PageHeader";

class Error404 extends Component {
  render() {
    const { breadcrumbs, content, title } = this.props;
    return (
      <Segment basic>
        <PageHeader
          title={title || "404 Page Not Found"}
          breadcrumbs={breadcrumbs || false}
        />
        {content || (
          <div>
            We could not find the content you were looking for. Please start
            again at the <Link to="/">home screen</Link>
          </div>
        )}
      </Segment>
    );
  }
}

export default Error404;
